import { FC } from 'react'
import styles from './deltaBadge.module.scss'

interface DeltaBadgeProps {
  className?: string
  // What follows the figure: "%" for a percent change, " pts" for a change in
  // score points.
  suffix?: string
  // null means "no previous period to compare against" — a new topic. That is
  // not the same as a delta of zero, so it renders nothing rather than 0%.
  value: number | null
}

export const DeltaBadge: FC<DeltaBadgeProps> = ({
  className,
  suffix = '%',
  value,
}) => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return null
  }

  // Exactly zero is neither a rise nor a fall. The design only draws an up and
  // a down arrow, so a flat period gets the figure with no arrow rather than an
  // arbitrary direction.
  const isFlat = value === 0
  const isUp = value > 0
  const magnitude = Math.abs(value)

  return (
    <span
      className={`${styles.delta} ${
        isFlat ? styles.flat : isUp ? styles.up : styles.down
      } ${className ?? ''}`}
    >
      {!isFlat && (
        <svg
          aria-hidden="true"
          className={styles.arrow}
          fill="none"
          viewBox="0 0 12 12"
        >
          <path
            d={
              isUp
                ? 'M6 9.5V2.5M6 2.5L3 5.5M6 2.5L9 5.5'
                : 'M6 2.5V9.5M6 9.5L3 6.5M6 9.5L9 6.5'
            }
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
        </svg>
      )}
      {magnitude}
      {suffix}
    </span>
  )
}
